<script>
export default {
	data() {
		return {
			rules: {
				required: value => {
					if (value == undefined || value == null || value == "") {
						return "Required";
					}

					return true;
				},
				password: value => {
					// TODO
					// min char to 8
					console.log("TO REMOVE");

					if (value == undefined || value == null || value == "") {
						return false;
					}

					if (value.length < 6) {
						return "Password should be at least 6 characters";
					}

					if (value.length < 8) {
						// return "Password should be at least 8 characters";
					}

					return true;
				},
				optionalPassword: value => {
					if (value == undefined || value == null || value == "") {
						return true;
					}

					if (value.length < 8) {
						return "Password should be at least 8 characters";
					}

					return true;
				},
				email: value => {
					const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
					if (pattern.test(value) == false) {
						return "Invalid E-mail";
					}

					return true;
				},
				nationalId: value => {
					// TODO
					// Change pattern to 10 char only
					console.log("TO REMOVE");
					const pattern = /^[0-9]{9,10}$/;
					if (pattern.test(value)) {
						return true;
					}

					return "Invalid National Id";
				},
				emailOrNationalId: value => {
					// TODO
					// Change pattern2 to 10 char only
					console.log("TO REMOVE");
					const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
					const pattern2 = /^[0-9]{9,10}$/;
					const isNumeric = /^[0-9]*$/;
					if (pattern.test(value)) {
						return true;
					}
					if (pattern2.test(value)) {
						return true;
					}
					if (isNumeric.test(value)) {
						return "Invalid National Id";
					}

					return "Invalid E-mail";
				}
			}
		};
	}
};
</script>